<template>
    <div class="discover-panel">
        <div class="discover-head">
            <div>
                <div class="discover-kicker">REQUESTS</div>
                <div class="discover-title">点歌结果</div>
                <div class="discover-sub">每首歌的处理结果都在这里；断线时请先核对队列。</div>
            </div>
            <button type="button" class="discover-close" aria-label="关闭点歌结果" @click="$emit('close')">
                <mu-icon value="close" :size="20"></mu-icon>
            </button>
        </div>
        <div class="discover-filter-row">
            <button type="button" class="discover-chip" :class="{'is-solid': !onlyBatch}" @click="onlyBatch = false">本次进入</button>
            <button v-if="lastBatchId" type="button" class="discover-chip" :class="{'is-solid': onlyBatch}" @click="onlyBatch = true">最近批量</button>
            <button type="button" class="discover-chip" @click="$store.commit('clearCompletedPickRequests')">清除已完成</button>
        </div>
        <div class="pick-result-summary" role="status" aria-live="polite">
            <span>处理中 {{ counts.processing }}</span>
            <span>已入队 {{ counts.queued }}</span>
            <span>未加入 {{ counts.failed }}</span>
            <span v-if="counts.unconfirmed">待确认 {{ counts.unconfirmed }}</span>
        </div>
        <div class="discover-list" v-if="shown.length">
            <div class="discover-row" v-for="item in shown" :key="item.requestId">
                <div class="discover-info">
                    <div class="discover-name">{{ item.name || item.musicId || '未知歌曲' }}</div>
                    <div class="discover-meta">{{ item.reason }}</div>
                </div>
                <div class="discover-actions">
                    <span class="pick-result-status" :class="'is-' + item.status">{{ label(item) }}</span>
                    <button v-if="(item.status === 'failed' || item.status === 'unconfirmed') && item.reason !== '已在播放列表'" type="button" class="discover-pick-btn" @click="$emit('retry', item)">重试</button>
                </div>
            </div>
        </div>
        <div v-else class="discover-empty">还没有点歌请求</div>
    </div>
</template>

<script>
export default {
    name: 'PickFeedback',
    data: () => ({onlyBatch: false}),
    computed: {
        requests() { return this.$store.getters.getPickRequests; },
        lastBatchId() {
            const item = this.requests.slice().reverse().find(item => item.batchId);
            return item && item.batchId;
        },
        shown() {
            return this.requests.filter(item => !this.onlyBatch || !this.lastBatchId || item.batchId === this.lastBatchId).slice().reverse();
        },
        counts() {
            const result = {processing: 0, queued: 0, failed: 0, unconfirmed: 0};
            this.shown.forEach(item => { if (item.status in result) result[item.status]++; });
            return result;
        }
    },
    methods: {
        label(item) {
            if (item.status === 'failed') return /不可播放/.test(item.reason) ? '不可播放' : '未加入';
            return {processing: '处理中', queued: '已入队', unconfirmed: '待确认'}[item.status] || '';
        }
    }
};
</script>

<style scoped>
.pick-result-summary { display: flex; flex-wrap: wrap; gap: 8px 18px; margin: 16px 0; color: var(--room-text-secondary); }
.pick-result-status { white-space: nowrap; color: var(--room-accent); font-size: 13px; }
.pick-result-status.is-failed, .pick-result-status.is-unconfirmed { color: var(--room-text-secondary); }
</style>
